import { render, staticRenderFns } from "./NotificationOops.vue?vue&type=template&id=b9c7ace2&scoped=true"
import script from "./NotificationOops.vue?vue&type=script&lang=ts"
export * from "./NotificationOops.vue?vue&type=script&lang=ts"
import style0 from "./NotificationOops.vue?vue&type=style&index=0&id=b9c7ace2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c7ace2",
  null
  
)

export default component.exports